<template>
  <div class="float-block">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FloatBlock'
}
</script>

<style lang="scss" scoped>
.float-block {
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FloatBlock.vue